import { User } from '../models/user.model';

export interface UserLoggedInPayload {
  user: User;
}

export class UserLoggedIn {
  public static readonly type = '[Auth] Logged In';
  constructor(public payload: UserLoggedInPayload) {}
}

export class UserAllowedClaimsPreAuth {
  static readonly type = '[AUTH] User Allowed Claims Pre-Auth';
}

export class FetchFeatureFlags {
  static readonly type = '[AUTH] Fetch Feature Flags';
}
